//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'
import { mdiMenuLeft, mdiMenuRight } from '@mdi/js'

export default {
  setup() {
    const currentPage = ref(1)

    return {
      currentPage,

      // Icons
      icons: {
        mdiMenuLeft,
        mdiMenuRight,
      },
    }
  },
}
